import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { isType3, userTypeList } from 'main_consts';

// ICON
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import colW from 'components/NewTable/consts';
import { TableColumn } from 'components/NewTable/type';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import NewTable from 'components/NewTable/index';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  isOverDayRange,
  formatDate,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSaveExcelFile,
  getSearchByPage,
  snackBarRsp,
} from '../../../main_api';

import {
  Imaster,
  IRptInOutDailyQry,
  ISearchResult,
  ISearchResultList,
} from './type';
import { Iobject } from '../../../main_type';

/** 進出倉交接表 */
const RptInOutDailyQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 進出口別
    declType: '1',
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    qryType: 'H',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    display: 'N',
    endDateValid: true,

    startDateValid: true,
    ioType: '1',
    page: 0,
    pageSize: 10,
    count: 0,
  };
  // 如下載筆數超過 excelMaxCount，轉至下載專區
  const apiName = 'rptInOutDailyQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<ISearchResultList[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  // 當下載是進入下載專區(getSaveExcelFile)時，下載按鈕disabled，直到換日期
  const [isDownload, setIsDownload] = useState(false);
  const [listCol, setListCol] = useState<TableColumn[]>([]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const param: IRptInOutDailyQry = {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      startDate: formatDate(master.startDate, 'yyyy/MM/dd'),
      endDate: formatDate(master.endDate, 'yyyy/MM/dd'),
      display: master.display,
      ioType: master.ioType,
      qryType: master.qryType,
      check: false,
    };
    dispatch(setLoadingRedux(true));
    // #region  2021-02-27 - qryType為 H(分號)的情況下，先查詢結果筆數，在決定要 直接下載 還是 轉入下載專區
    if (master.qryType === 'H') {
      const saveExcelResult = await getSaveExcelFile(param, true);
      if (saveExcelResult && saveExcelResult.data.status !== 1) {
        dispatch(setLoadingRedux(false));
        snackBarRsp(enqueueSnackbar, saveExcelResult);
        return;
      }
    }
    // #endregion
    const result = await getExcel(apiName, param);
    const startDate = formatDate(master.startDate, 'yyyy/MM/dd');
    const EndDate = formatDate(master.endDate, 'yyyy/MM/dd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${user.id}_${
        master.chkCode1.length > 0 ? `${master.chkCode1}_` : ''
      }${startDate}_${EndDate}_${
        master.qryType === 'H' ? '分號' : '主號'
      }_進出倉交接表_${master.ioType === '1' ? '進倉日' : '出倉日'}.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const getTbData = async (
    page = masterDefaultValue.page,
    pageSize = masterDefaultValue.pageSize
  ) => {
    dispatch(setLoadingRedux(true));
    const result = await getSearchByPage(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      display: master.display,
      qryType: master.qryType,
      ioType: master.ioType,
      startDate: formatDate(master.startDate, 'yyyy/MM/dd'),
      endDate: formatDate(master.endDate, 'yyyy/MM/dd'),
      pageNum: page,
      pageSize,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const resultData = result.data.data as ISearchResult;
    if (result.data.status === 0) {
      setMaster((prev) => ({
        ...prev,
        page: resultData.pageNum - 1,
        pageSize: resultData.pageSize,
        count: resultData.total,
      }));
      if (resultData.list.length > 0) {
        switch (master.qryType) {
          case 'H':
            setListCol([
              { w: colW[1], t: '項次', f: 'index' },
              { w: colW[2], t: '海掛', f: 'vesselRegNo' },
              { w: colW[8], t: '櫃號', f: 'containerNo' },
              { w: colW[8], t: '封條號碼', f: 'sealNo' },
              { w: colW[8], t: '分號', f: 'hawbNo' },
              { w: colW[8], t: '主號', f: 'mawbNo' },
              { w: colW[6], t: '航次', f: 'voyageNo' },
              { w: colW[8], t: '報單號碼', f: 'declNo' },
              { w: colW[1], t: '類別', f: 'appType' },
              { w: colW[3], t: '通關方式', f: 'goodsStat' },
              { w: colW[1], t: '申報', f: 'piece' },
              { w: colW[1], t: '進倉', f: 'gciPiece' },
              { w: colW[1], t: '出倉', f: 'gcoPiece' },
              { w: colW[3], t: '申報重量', f: 'weight' },
              { w: colW[8], t: '進倉日期', f: 'gciDate1' },
              { w: colW[8], t: '出倉日期_1', f: 'gcoDate1' },
              { w: colW[8], t: '出倉日期_end', f: 'gcoDate2' },
              { w: colW[2], t: '存倉天數', f: 'storageDate' },
              { w: colW[2], t: '記帳代號', f: 'expresssNameOrExpressId' },
              {
                w: colW[2],
                t: master.declType === '1' ? '艙號' : '裝貨單號',
                f: 'manifNo',
              },
              { w: colW[8], t: '快遞倉站', f: 'warehouse' },
              { w: colW[2], t: '報關箱號', f: 'boxNo' },
            ]);
            break;
          case 'M':
            setListCol([
              { w: colW[1], t: '項次', f: 'itemNo' },
              { w: colW[1], t: '#', f: 'index' },
              { w: colW[8], t: '主號', f: 'mawbNo' },
              { w: colW[8], t: '分號數', f: 'hwbCnt' },
              { w: colW[2], t: '申報', f: 'piece' },
              { w: colW[2], t: '進倉', f: 'gciPiece' },
              { w: colW[2], t: '出倉', f: 'gcoPiece' },
              { w: colW[3], t: '申報重量', f: 'weight' },
              { w: colW[3], t: '進倉重量', f: 'gciWeight' },
            ]);
            break;

          default:
            break;
        }

        setRowData(
          resultData.list.map((v, i) => {
            return {
              ...v,
              id: String(i),
              index: resultData.startRow + i,
            };
          })
        );
        setOpenSearchTable(true);
      } else {
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
    }
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    // #region  新增判斷 如果超過 N 天就return 並顯示錯誤訊息
    const dayRange = 7;
    if (isOverDayRange(`${master.startDate}`, `${master.endDate}`, dayRange)) {
      enqueueSnackbar(`查詢不可超過 ${dayRange} 天`);
      return;
    }
    // #endregion
    getTbData();
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (
      !master.endDateValid ||
      !master.startDateValid ||
      !(master.startDate && master.endDate)
    ) {
      return;
    }
    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  useEffect(() => {
    setIsDownload(false);
  }, [master.startDate, master.endDate]);

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area" />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 進出倉交接表
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name="declType"
                value={master.declType}
                onChange={radioChange(updateData)}
                options={[
                  { value: '1', label: '進口' },
                  { value: '2', label: '出口' },
                ]}
              />
            </VcGrid>
          </Grid>
          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={2}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出倉別：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name="ioType"
                value={master.ioType}
                onChange={radioChange(updateData)}
                options={[
                  { value: '1', label: '進倉時間' },
                  { value: '2', label: '出倉時間' },
                ]}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*查詢日期區間：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateSePickersTyping
                key={random}
                required
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={['startDate', 'endDate']}
                data={master}
                seInterval={
                  userTypeList.admin.indexOf(userType) !== -1 ||
                  userTypeList.type1.indexOf(userType) !== -1
                    ? 31
                    : 7
                }
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              查詢方式：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name="qryType"
                value={master.qryType}
                onChange={radioChange(updateData)}
                options={[
                  { value: 'H', label: '分號' },
                  { value: 'M', label: '主號' },
                ]}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              過磅重量值是否顯示：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name="display"
                value={master.display}
                onChange={radioChange(updateData)}
                options={[
                  { value: 'N', label: '否' },
                  { value: 'Y', label: '是' },
                ]}
              />
            </VcGrid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError || isDownload}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <NewTable<ISearchResultList>
          serverRender
          data={rowData}
          columns={listCol}
          page={master.page}
          pageSize={master.pageSize}
          count={master.count}
          // renderCell={renderCell}
          onPageChange={async (page, pageSize) => {
            await getTbData(page, pageSize);
          }}
        />
      )}
    </div>
  );
};

export default RptInOutDailyQry;
